import React, { useState, useEffect } from 'react'


export function TeamMemberFeedback(props) {

    const [empFeedback, setEmpFeedback] = useState([])
    const [textArea, setTextArea] = useState(false)
    const [showAddFeedback2, setshowAddFeedback2] = useState(false)
    const [showAddFeedback, setshowAddFeedback] = useState(false)
    const [flag, setflag] = useState(false)


    useEffect(() => {
        let resp = (props.EmployeeFeedback !== undefined && props.EmployeeFeedback !== null) ? setEmpFeedback(props.EmployeeFeedback) : []

        if (props.EmployeeFeedback !== undefined && props.EmployeeFeedback !== null) {
            if (props.EmployeeFeedback.length > 0) {
                setshowAddFeedback(props.EmployeeFeedback?.some(el => el.employee_id === props.Details.roleId))
            }
        }
    }, [])


    const bindempInfo = () => {
        return empFeedback.map(emp => {
            return (
                <>
                    <p className="font-12 medium-text touchbase-feedback-text">{emp.employee_feedback}</p>
                    <p className="text-end mt-2 font-12 medium-text touchbase-submitted-color">Submitted by {emp.employee_name}</p>

                </>
            )
        })
    }

    const bindempText = () => {
        if (empFeedback.length > 0) {
            return empFeedback.map(emp => {
                return (
                    <>
                        {(emp.employee_id === props.Details.roleId) ? <textarea maxLength={3000} onChange={(e) => { employeeInfo(e) }} className="form-control hive-form-control touchbase-comments" id="teammember-feedback" placeholder="Enter Here" rows={3} defaultValue={emp.employee_feedback} />
                            : <p className="font-12 medium-text touchbase-feedback-text">{emp.employee_feedback}</p>}
                        <p className="text-end mt-2 font-12 medium-text touchbase-submitted-color">Submitted by {emp.employee_name}</p>
                    </>
                )
            })
        }
    }

    const clickedAddButton = () => {
        setshowAddFeedback2(true)
        setshowAddFeedback(true)
        setTextArea(true)
        setflag(!flag)
    }

    const employeeInfo = (e) => {
        empFeedback.map(emp => {
            if (emp.employee_id == props.Details.roleId) {
                emp.employee_feedback = e.target.value
            }
        })
        props.onSubmit(empFeedback, "Team Member")
    }

    const newFeedback = (e) => {

        let newArray = []
        let obj = {
            employee_feedback: e.target.value,
            employee_id: props.Details.roleId
        }
        newArray.push(obj)
        props.onSubmit(newArray, "Team Member")
    }

    let duplicateArray = empFeedback


    let empAlreadyFilled = duplicateArray.length > 0 && duplicateArray !== undefined ? duplicateArray?.some(el => el.employee_id === props.Details.roleId) : false



    return (
        <>
            {(empFeedback.length !== 0 && props.Details.role !== 'Team Member') ? bindempInfo() : props?.status === 'Completed' ? bindempInfo() : bindempText()}


            {textArea ?
                <>
                    <textarea maxLength={3000} onChange={(e) => { newFeedback(e) }} className="form-control hive-form-control touchbase-comments" id="teammember-feedback" placeholder="Enter Here" rows={3} defaultValue={""} />
                    <p className="text-end mt-2 font-12 medium-text touchbase-submitted-color">Submitted by {props.Details.name}</p> </>
                :
                showAddFeedback ? null :
                    empFeedback.length === 0 && props.Details.role === 'Team Member' && props?.status != 'Completed' ?
                        <> <textarea maxLength={3000} onChange={(e) => { newFeedback(e) }} className="form-control hive-form-control touchbase-comments" id="teammember-feedback" placeholder="Enter Here" rows={3} defaultValue={""} />
                            <p className="text-end mt-2 font-12 medium-text touchbase-submitted-color">Submitted by {props.Details.name}</p> </>
                        :
                        empFeedback.length === 0 ? <textarea disabled className="form-control hive-form-control touchbase-comments" id="teammember-feedback" placeholder="Enter Here" rows={3} defaultValue={""} /> : null}
            {(props.Details.role === 'Team Member') && empFeedback.length > 0 && !showAddFeedback && props?.status != 'Completed' ? <div className='row'>
                <a onClick={() => { clickedAddButton() }} className="semibold-text font-13 add-feedback align-middle"><img src="/Images/add-feedback.svg" className=" me-1" alt="add-feedback" />Add Team Member Feedback</a></div>
                : null}

        </>
    )

}
